export const ibanRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.5rem 0.75rem',
  border: '1px solid #e5e7eb',
  borderRadius: '0.375rem',
  backgroundColor: '#ffffff',
  cursor: 'grab',
  textAlign: 'left',
  '&:active': {
    cursor: 'grabbing'
  }
} as const;

export const ibanRowDraggedStyle = {
  opacity: 0.4
} as const;

export const ibanRowDragOverStyle = {
  borderColor: '#078dee'
} as const;

export const ibanRowPrimaryStyle = {
  backgroundColor: '#e6f4ea',
  borderColor: '#c6e6cf'
} as const;

export const ibanPrimaryBadgeStyle = {
  backgroundColor: '#c8e6c9',
  color: '#2e7d32',
  fontSize: '0.6875rem',
  fontWeight: 600,
  height: '1.25rem',
  borderRadius: '0.75rem',
  '& .MuiChip-label': {
    padding: '0 0.5rem',
    color: '#2e7d32'
  }
} as const;

export const ibanHintStyle = {
  fontSize: '0.75rem',
  color: '#9ca3af',
  textAlign: 'left'
} as const;

export const fieldLabelStyle = {
  fontSize: '0.75rem',
  color: '#374151',
  textAlign: 'left'
} as const;

export const expenseTypeChipStyle = {
  backgroundColor: '#e5f4fd',
  color: '#078dee',
  '& .MuiChip-label': {
    fontSize: '0.75rem',
    color: '#078dee'
  },
  '& .MuiChip-deleteIcon': {
    color: '#078dee',
    '&:hover': {
      color: '#ef4444'
    }
  }
} as const;

export const approvalWarningContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: '0.75rem 1rem',
  borderRadius: '0.25rem',
  borderLeft: '4px solid #ed6c02',
  backgroundColor: '#fffbf2',
  textAlign: 'left'
} as const;

export const approvalWarningHeadingStyle = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  color: '#ed6c02',
  textAlign: 'left'
} as const;

export const approvalWarningRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '0.75rem',
  color: '#663c00',
  textAlign: 'left'
} as const;

export const approvalSuccessContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.75rem 1rem',
  borderRadius: '0.25rem',
  border: '1px solid #c8e6c9',
  backgroundColor: '#f6fbf6',
  textAlign: 'left'
} as const;

export const approvalSuccessTitleStyle = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  color: '#1e4620',
  textAlign: 'left'
} as const;

export const approvalSuccessTextStyle = {
  fontSize: '0.75rem',
  color: '#2e7d32',
  textAlign: 'left'
} as const;
